import React, { Component } from "react";
import {
  Button,
  Row,
  Col,
  Card,
  Container,
  Accordion,
  Spinner,
} from "react-bootstrap";

import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
} from "reactstrap";
import logo from "../../static/Images/logo.png";
import { FaUserAlt, FaStar } from "react-icons/fa";
import { Link, withRouter } from "react-router-dom";
import Oplogo from "../../static/Images/mojo.png";
import RichTextContent, { hasTextContent } from "./RichTextContent";

import DestinationImage from "../../static/Images/destination1.jpg";
import Background from "../../static/Images/destination.jpg";
import BeautyStars from "beauty-stars";
import FD5 from "../../static/Images/FD5.jpg";
import FD2 from "../../static/Images/FD2.jpg";
import FD3 from "../../static/Images/FD3.jpg";

import FD4 from "../../static/Images/FD4.jpg";
import ButtonCommon from "./ButtonCommon";
import OperatorReviews from "./OperatorReviews";
import Awards from "./Awards";
import OperatorTours from "./OperatorTours";
import AskOperatorQuestions from "./AskOperatorQuestion";
import Api from "../Service/Api";
import NavBar from "./NavBar";
import Loaders from "./FullScreenLoader";

class OperatorDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operatorInfo: {},
      active: true,
      reviewslist: [],
      eventlist: [],
      loader: false,
      operatorquelist: [],
      faqscalled: false,
      ratings: 0,
      reviewscount: 0,
    };
  }

  componentDidMount() {
    const operatorId = this.props.match?.params?.id;

    if (!operatorId) {
      console.error("Operator ID not found in route params");
      this.setState({ active: false, loader: false });
      return;
    }

    this.setState({ loader: true });

    Api.get(`/operators/${operatorId}/user?relations=["user"]`)
      .then((res) => {
        this.setState({
          operatorInfo: res.data,
          active: false,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({ active: false, loader: false });
      });

    Api.get(`/operators/${operatorId}/reviews/average`)
      .then((res) => {
        this.setState({ ratings: res.data?.rating || 0 });
      })
      .catch((err) => {});

    Api.get(`/operators/${operatorId}/reviews/count`)
      .then((res) => {
        this.setState({ reviewscount: res.data?.count || 0 });
      })
      .catch((err) => {});

    Api.get(
      `/operators/${operatorId}/reviews?relations=["user"]&order={"updatedOn":"DESC"}`,
    )
      .then((res) => {
        this.setState({ reviewslist: res.data || [] });
      })
      .catch((err) => {});

    Api.get(`/operators/${operatorId}/events?skip=0&limit=10`)
      .then((res) => {
        this.setState({ eventlist: res.data || [] });
      })
      .catch((err) => {});

    this.getoperatorfaqs(operatorId);
  }

  getoperatorfaqs = (operatorId) => {
    if (!this.state.faqscalled && operatorId) {
      Api.get(`/operators/${operatorId}/faqs`)
        .then((res) => {
          this.setState({
            operatorquelist: res.data || [],
            faqscalled: true,
          });
        })
        .catch((err) => {});
    }
  };

  render() {
    const {
      operatorInfo,
      active,
      ratings,
      reviewscount,
      reviewslist,
      eventlist,
      loader,
      operatorquelist,
    } = this.state;

    const list =
      this.props?.location?.state?.list ||
      this.props?.history?.location?.state?.list ||
      null;

    const operatorId = this.props?.match?.params?.id;
    const user = operatorInfo?.user || {};

    return (
      <div className="">
        {loader && <Loaders />}
        {!active && (
          <div>
            <div
              className="banner"
              style={{
                backgroundImage:
                  list && list.banner
                    ? `url(${list.banner})`
                    : `url(${Background})`,
                width: "100%",
                backgroundSize: "cover",
                height: "75vh",
                position: "relative",
                backgroundPosition: "50% 50%",
              }}
            >
              <NavBar />
              <div
                className="eventopacity"
                style={{
                  backgroundColor: "black",
                  height: "100%",
                  opacity: "0.5",
                }}
              />
              <div className="text-center">
                <div className="circle-border"></div>
                <div className="circle-image">
                  <img
                    className="circle_image"
                    src={user.profileImage?.md}
                    alt={user.name || "Operator"}
                  />
                </div>
              </div>
            </div>

            <section className="">
              <Container>
                <Card style={{ marginTop: "50px" }} className="Card-style">
                  <Card.Body>
                    <Row>
                      <Col lg={12}>
                        <div className="profile-tb_operator">
                          <h2>{user.name}</h2>
                          {user.city && user.country && (
                            <h4>
                              {user.city}, {user.country}
                            </h4>
                          )}

                          <h4>
                            <FaStar
                              style={{
                                color: "rgb(253, 215, 42)",
                                fontSize: "1rem",
                              }}
                            />{" "}
                            {ratings}/5
                          </h4>

                          <h4>Reviews ({reviewscount})</h4>
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "15px" }}>
                      <Col lg={10}>
                        <h2>About</h2>
                        {hasTextContent(user.about) && (
                          <RichTextContent
                            content={user.about}
                            className="para_description"
                          />
                        )}
                      </Col>
                      <Col lg={2}>
                        {operatorId && (
                          <AskOperatorQuestions opid={operatorId} />
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Row>
                  <Col lg={12}>
                    <OperatorReviews reviewslist={reviewslist} />
                  </Col>
                </Row>

                {eventlist && eventlist.length > 0 && (
                  <Row>
                    <OperatorTours
                      history={this.props.history}
                      eventlist={eventlist}
                    />
                  </Row>
                )}

                {operatorquelist.length > 0 && (
                  <Row style={{ marginTop: "15px" }}>
                    <Col lg={12}>
                      <Accordion className="h2-text-event-details">
                        <Card className="toogle-card">
                          <h2 className="reviewTitle">FAQ</h2>
                          {operatorquelist.map((item, index) => (
                            <Accordion.Toggle
                              key={index}
                              className="Card-style card-headers accCard"
                              as={Card.Header}
                              eventKey={index + 1}
                            >
                              <Row>
                                <Col lg={11}>
                                  <h2>{item?.question}</h2>
                                  <Accordion.Collapse eventKey={index + 1}>
                                    <Card.Body
                                      style={{
                                        paddingTop: "10px",
                                        paddingBottom: "15px",
                                      }}
                                    >
                                      <p style={{ marginBottom: "0px" }}>
                                        {item?.answer}
                                      </p>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Col>
                              </Row>
                            </Accordion.Toggle>
                          ))}
                        </Card>
                      </Accordion>
                    </Col>
                  </Row>
                )}
              </Container>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(OperatorDetails);
